<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>Performance Analytics<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody"> 
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadPerformanceAnalytics(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul> 
          <div class="divider ">
            <hr>
          </div>
            <div class="filterTitle">
            <h5>Filters</h5>
            <p class="text-danger mb-3">Note: Please select a Academy first to view available usernames.</p>
          </div>
           <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
               <p-dropdown inputId="totalCoaches" [options]="yearlist" [filter]="true"
                  (onChange)="loadPerformanceAnalytics($event)" placeholder="Select Year" optionLabel="label"
                  optionValue="value" appendTo="body" [showClear]="true" [(ngModel)]="year"></p-dropdown>
                </li>
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                  (onChange)="getBatchPlayers($event)" placeholder="Select Academy" optionLabel="name"
                  optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="academyId"></p-dropdown>
                </li>
                <li>
                 <p-dropdown inputId="totalCoaches" [options]="months" [filter]="true"
                  (onChange)="loadPerformanceAnalytics($event)" placeholder="Select Month" optionLabel="label"
                  optionValue="value" appendTo="body" [showClear]="true" [(ngModel)]="month"></p-dropdown>
                </li>
                <li>
                <p-dropdown inputId="totalCoaches" [options]="batchPlayers" [filter]="true"
                  (onChange)="loadPerformanceAnalytics($event)" placeholder="Select username" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="username"></p-dropdown>  
                </li> 
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="batchCategoryList" [filter]="true"
                  (onChange)="loadPerformanceAnalytics($event)" placeholder="Select category" optionLabel="name"
                  optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="category"></p-dropdown>
                </li> 
              </ul>
            </div>
          </div>
         
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="performanceAnalyticsData" [autoLayout]="true" [paginator]="true" [rows]="10"
              [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadPerformanceAnalytics($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="userNameTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="academyName">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="academyName"></p-sortIcon>
                    </div>
                  </th>

                  <th pSortableColumn="created_at" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon field="created_at"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="fullName" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Academy <p-sortIcon field="fullName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="userNameTD" pSortableColumn="transferAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Month <p-sortIcon
                        field="transferAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="transferCreditTD" pSortableColumn="totalCreditedAmount">
                    <div class="p-d-flex p-jc-between p-ai-center"> Year <p-sortIcon
                        field="totalCreditedAmount"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="bankName  " >
                    <div class="p-d-flex p-jc-between p-ai-center"> Category <p-sortIcon field="bankName"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber  " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Forehand Groundstroke <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'"  >
                    <div class="p-d-flex p-jc-between p-ai-center"> Top Spin <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Slice <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Backhand Groundstroke <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber  " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Top Spin <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th><th class="BankDteailsTD" pSortableColumn="accountNumber  " [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Slice <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Forehand Approach <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Backhand Approach <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Forehand Volley <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Backhand Volley <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Smash <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Serve <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> First Serve <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Second Serve <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Flat <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Slice <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Top Spin <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Return of Serve <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Power <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Control <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Consistency <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Shot Selection <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Footwork <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Physical Fitness <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Speed <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Stamina <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Strength <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Flexibility <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Match Temperament <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mental Fitness <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Discipline <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="BankDteailsTD" pSortableColumn="accountNumber show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Avg Score <p-sortIcon
                        field="accountNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th class="sorting_disabled text-nowrap p-element p-frozen-column action-button-td" rowspan="1"
                    colspan="1" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th [ngSwitch]="academyName" pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'academyName', 'contains')"
                      [value]=" dt.filters['academyName'] ? dt.filters['academyName'].value : ''" /> -->
                  </th>

                  <th [ngSwitch]="userName" class="userNameTD p-element   text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="created_at" class="userNameTD">
                    <!-- <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                      [value]=" dt.filters['userName'] ? dt.filters['userName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="transferAmount" class="userNameTD p-element text-nowrap" style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'transferAmount', 'contains') "
                      [value]=" dt.filters['transferAmount'] ? dt.filters['transferAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="totalCreditedAmount" class="transferCreditTD p-element   text-nowrap"   
                    style="left: 0px">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'totalCreditedAmount', 'contains') "
                      [value]=" dt.filters['totalCreditedAmount'] ? dt.filters['totalCreditedAmount'].value : '' " /> -->
                  </th>
                  <th [ngSwitch]="bankName " class="BankDteailsTD show-col" style="left: 0px"   >
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'bankName', 'contains')"
                      [value]=" dt.filters['bankName'] ? dt.filters['bankName'].value : ''" /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col"  [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
                  <th [ngSwitch]="accountNumber" class="BankDteailsTD show-col" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <!-- <input pInputText type="text"
                      (keyup.enter)=" setDownloadFlag(); dt.filter($event.target.value, 'accountNumber', 'contains') "
                      [value]=" dt.filters['accountNumber'] ? dt.filters['accountNumber'].value: '' " /> -->
                  </th>
             
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-performanceAnalyticsList>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="userNameTD p-element text-nowrap">
                    <div class="textOverFlow1" pTooltip="	{{performanceAnalyticsList?.mobileNumber}}" tooltipPosition="bottom">
                      {{performanceAnalyticsList?.mobileNumber}}
                    </div>
                  </td>

                  <td class="userNameTD">
                    {{ performanceAnalyticsList?.username }}
                  </td>
                  <td class="userNameTD">
                    {{ performanceAnalyticsList?.academy }}
                  </td>
                  <td class="userNameTD">
                    {{ performanceAnalyticsList?.month }}
                  </td>
                  <td class="transferCreditTD">
                    {{ performanceAnalyticsList?.year }}
                  </td>
                  <td class="BankDteailsTD">
                    {{ performanceAnalyticsList?.category }}
                  </td>
                  <td class="BankDteailsTD"  [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.forehandGroundstroke }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.topSpin }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.slice }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.backhandGroundstroke }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.topSpin }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.slice }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.forehandApproach }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.backhandApproach }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.forehandVolley }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.backhandVolley }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.smash }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.serve }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.firstServe }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.secondServe }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.flat }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.slice }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.topSpin }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.returnOfServe }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.power }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.control }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.consistency }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.shotSelection }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.footwork }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.physicalFitness }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.speed }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.stamina }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.strength }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.flexibility }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.matchTemperament }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.mentalFitness }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.discipline }}
                  </td>
                  <td class="BankDteailsTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ performanceAnalyticsList?.avgScore }}
                  </td>
                 
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                    
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">Performance analytics list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
